module.exports = __webpack_public_path__ + "static/media/doctor-mask-rev .ed8a49d7.jpg";